export const performanceRoutes = {
  dashboard: "/performance",
  dashboardLegacy: "/performance/dashboard",
  goals: "/performance/goals",
  goalDetail: (goalId = ":goalId") => `/performance/goals/${goalId}`,
  checkins: "/performance/checkins",
  feedback: "/performance/feedback",
  feedbackDetail: (feedbackId = ":feedbackId") =>
    `/performance/feedback/${feedbackId}`,
  feedbackReceived: "/performance/feedback/received",
  competencies: "/performance/competencies",
  competencyCategories: "/performance/competencies/categories",
  campaigns: "/performance/360/campaigns",
  campaignDetail: (campaignId = ":campaignId") =>
    `/performance/360/campaigns/${campaignId}`,
  campaignReviews: "/performance/360/reviews",
  reviews: "/performance/reviews",
  myReviews: "/performance/reviews/my",
  teamReviews: "/performance/reviews/team",
  generateReviews: "/performance/reviews/generate",
  reviewDetail: (reviewId = ":reviewId") => `/performance/reviews/${reviewId}`,
  pmsFormatTemplates: "/performance/pms-format/templates",
  pmsFormatTemplateCreate: "/performance/pms-format/templates/create",
  pmsFormatTemplateImport: "/performance/pms-format/templates/import",
  pmsFormatTemplateDetail: (templateId = ":templateId") =>
    `/performance/pms-format/templates/${templateId}`,
  pmsFormatTemplateEdit: (templateId = ":templateId") =>
    `/performance/pms-format/templates/${templateId}/edit`,
  pmsFormatTemplateVersions: (templateId = ":templateId") =>
    `/performance/pms-format/templates/${templateId}/versions`,
  pmsFormatTemplateVersion: (templateId = ":templateId", version = ":version") =>
    `/performance/pms-format/templates/${templateId}/versions/${version}`,
  pmsFormatRatingScales: "/performance/pms-format/rating-scales",
  pmsFormatRatingScaleCreate: "/performance/pms-format/rating-scales/create",
  pmsFormatRatingScaleDetail: (ratingScaleId = ":ratingScaleId") =>
    `/performance/pms-format/rating-scales/${ratingScaleId}`,
  pmsFormatRatingScaleEdit: (ratingScaleId = ":ratingScaleId") =>
    `/performance/pms-format/rating-scales/${ratingScaleId}/edit`,
  pmsFormatImports: "/performance/pms-format/imports",
  pmsFormatImportDetail: (importId = ":importId") =>
    `/performance/pms-format/imports/${importId}`,
  calibrations: "/performance/calibrations",
  calibrationDetail: (id = ":id") => `/performance/calibrations/${id}`,
  analytics: "/performance/analytics",
  goalCycles: "/performance/masters/goal-cycles",
  feedbackTypes: "/performance/masters/feedback-types",
};

export default performanceRoutes;
